import { render, staticRenderFns } from "./WarehouseReceipt.vue?vue&type=template&id=6c0ae5ed&scoped=true"
import script from "./WarehouseReceipt.vue?vue&type=script&lang=js"
export * from "./WarehouseReceipt.vue?vue&type=script&lang=js"
import style0 from "./WarehouseReceipt.vue?vue&type=style&index=0&id=6c0ae5ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ae5ed",
  null
  
)

export default component.exports